import restArguments from './restArguments.js';
import flatten from './_flatten.js';
import bind from './bind.js';
// Bind a number of an object's methods to that object. Remaining arguments
// are the method names to be bound. Useful for ensuring that all callbacks
// defined on an object belong to it.
export default restArguments(function (obj, keys) {
    keys = flatten(keys, false, false);
    var index = keys.length;
    if (index < 1)
        throw new Error('bindAll must be passed function names');
    while (index--) {
        var key = keys[index];
        obj[key] = bind(obj[key], obj);
    }
    return obj;
});
